//   特价秒杀
export default [{
  path: '/specialSpike',
  name: 'specialSpike',
  meta: {
    index: 2
  },
  component: () => import('@/views/specialSpike/index')
}]
